/**
 * Recent Registrations Table Component
 * Shows recent company registrations with details
 */
import React from 'react';
import { Card, Tag } from 'antd';
import { RecentRegistration } from '../../services/superAdminService';
import './RecentRegistrations.css';

interface RecentRegistrationsProps {
  data?: RecentRegistration[];
  loading?: boolean;
}

const RecentRegistrations: React.FC<RecentRegistrationsProps> = ({ data, loading = false }) => {
  if (loading || !data || data.length === 0) {
    return (
      <Card className="recent-registrations-card" loading={true}>
        <div className="registrations-header">
          <div className="registrations-title">Recent Registrations</div>
        </div>
      </Card>
    );
  }

  const getTypeBadge = (type: string | null) => {
    if (type === 'macro' || type === 'Macro') {
      return <Tag color="purple" className="type-badge macro">Macro</Tag>;
    }
    if (type === 'micro' || type === 'Micro') {
      return <Tag color="blue" className="type-badge micro">Micro</Tag>;
    }
    return <Tag color="default" className="type-badge">-</Tag>;
  };

  const getStatusBadge = (isActive: boolean) => {
    if (isActive) {
      return <Tag color="green" className="status-badge active">Active</Tag>;
    }
    return <Tag color="red" className="status-badge inactive">Inactive</Tag>;
  };

  return (
    <Card className="recent-registrations-card">
      <div className="registrations-header">
        <div className="registrations-title">Recent Registrations</div>
        <button type="button" className="view-all-link" onClick={() => {}}>View All →</button>
      </div>
      <table className="registrations-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>COMPANY</th>
            <th>TYPE</th>
            <th>STATUS</th>
            <th className="text-right">USERS</th>
            <th className="text-right">LOCATIONS</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={row.id} className={index === 2 ? 'highlighted-row' : ''}>
              <td>{row.code}</td>
              <td>{row.name}</td>
              <td>{getTypeBadge(row.license_type)}</td>
              <td>{getStatusBadge(row.is_active)}</td>
              <td className="text-right">{row.total_users}</td>
              <td className="text-right">{row.total_locations}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Card>
  );
};

export default RecentRegistrations;
